import React from "react";

export const bellFilled = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <g fill="currentColor">
        <path d="M18.631 14.065V9.51a6.64 6.64 0 0 0-4.523-6.288V2.108A2.11 2.11 0 0 0 12 0a2.11 2.11 0 0 0-2.108 2.108v1.114A6.64 6.64 0 0 0 5.368 9.51v4.555c0 .754-.277 1.478-.78 2.038a4.45 4.45 0 0 0-1.142 2.977v1.006c0 .608.495 1.103 1.103 1.103h4.595A2.86 2.86 0 0 0 12 24a2.86 2.86 0 0 0 2.856-2.811h4.595c.608 0 1.103-.495 1.103-1.104V19.08a4.45 4.45 0 0 0-1.141-2.977 3.04 3.04 0 0 1-.782-2.038M11.297 2.108a.704.704 0 0 1 1.406 0v.808a6.7 6.7 0 0 0-1.406 0zM6.774 9.51A5.23 5.23 0 0 1 12 4.284a5.23 5.23 0 0 1 5.226 5.226v4.555c0 1.07.384 2.098 1.081 2.907H5.693a4.45 4.45 0 0 0 1.081-2.907zM12 22.594a1.453 1.453 0 0 1-1.45-1.405h2.9A1.453 1.453 0 0 1 12 22.594m7.149-2.81H4.85v-.704q0-.359.082-.702h14.134q.081.343.082.702z" />
        <path d="M6 11c-.8-4.4 2.667-6.5 4.5-7 5.2-1.6 6.833 2 7 4l.5 7.5 1.5 2.5.5 2.5H4.5V18c2-2.4 1.833-5.667 1.5-7" />
        <circle cx="12" cy="21" r="2" />
      </g>
    </svg>
  );
};
